/**
 * Formats a file size in bytes into a human-readable string with units.
 *
 * @param {number} [size=0] - The file size in bytes.
 * @returns {string} The formatted file size string with appropriate units (B, KB, MB, GB, TB).
 */
export function formatFileSize(size = 0): string {
  const index = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024))

  return (
    +(size / Math.pow(1024, index)).toFixed(2) * 1 +
    ' ' +
    ['B', 'KB', 'MB', 'GB', 'TB'][index]
  )
}
